<template>
  <v-toolbar color="orange" fixed dark app>
    <v-toolbar-title>
      <v-toolbar-side-icon @click="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
    <!--<v-text-field flat solo-inverted prepend-inner-icon="search" :label="$t('toobar.search')" clearable class="search"></v-text-field>-->
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <!--<v-btn flat href="mailto:wangqiangshen@gmail.com">Hire Me</v-btn>-->
      <!--<v-btn icon href="https://github.com/tookit/vue-material-admin">-->
        <!--<v-icon class="fa-2x">fa-github</v-icon>-->
      <!--</v-btn>-->
      <!--<v-btn icon @click="handleFullScreen()">-->
        <!--<v-icon>fullscreen</v-icon>-->
      <!--</v-btn>-->
      <div class="ml-auto cols-auto" style="padding-top: 20px">
        <a style="color: black">Logged in as {{user}}({{role}})</a>
      </div>
      <!--<v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon flat @click="onBell" v-on="on" v-if="show">
            <v-badge color="red" overlap>
              <span slot="badge" v-if="count != 0">{{count}}</span>
              <v-icon medium>notifications</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Terdapat {{count}} peminjaman yang baru diajukan</span>
      </v-tooltip>
        <!--<notification-list></notification-list>-->
      <!--</v-menu>-->
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-avatar size="30px">
            <img src="/static/jakarta_3.png" alt="Logo Jakarta 3" />
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            v-for="(item, index) in items"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
import NotificationList from "@/components/widgets/list/NotificationList"
import {getJWT,createJWT} from "../store/module/helper";
import {base} from "../setup-axios"
import Util from "@/util"

export default {
  name: "AppToolbar",
  components: {
    NotificationList
  },
  data() {
    return {
      items: [
        {
          icon: "fullscreen_exit",
          href: "#",
          title: "Logout",
          click: this.handleLogut
        }
      ],

      user: localStorage.getItem("user"),
      count: 0,
      role: ""
    }
  },
  created() {
    var decode = require('jwt-decode')
    var decoded = decode(getJWT())
    console.log(decoded)
    console.log(decoded.data.user_role_nama_singkat)
    this.role = decoded.data.user_role_nama_singkat
    localStorage.setItem("role", decoded.data.user_role_nama_singkat)
    localStorage.setItem("no_induk", decoded.data.no_induk)

    if(this.role == "admin"){
      base.get("penggunaanRuangan/countStatusPenggunaan" ,
        {
          headers: {
            'Authorization' : createJWT()
          }
        }
      ).then((resp) => {
        this.count = resp.data.result.count
      })
    }

    if(this.role == "RT") {
      base.get("penggunaanRuangan/non-akademik/status/1" ,
        {
          headers: {
            'Authorization' : createJWT()
          }
        }
      ).then((resp) => {
        this.count = resp.data.result.length
      })
    }

    if(this.role == "ruang") {
      base.get("penggunaanRuangan/akademik/status/1" ,
        {
          headers: {
            'Authorization' : createJWT()
          }
        }
      ).then((resp) => {
        this.count = resp.data.result.length
      })
    }
  },
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav
    },

    show: function () {
      this.role;
      return this.role == "admin" || this.role == "RT" || this.role == "ruang";
    }
  },
  methods: {
    handleDrawerToggle() {
      this.$emit("side-icon-click")
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    handleLogut() {
      //handle logout
      document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
      this.$router.push('/')
      localStorage.removeItem("user");
      localStorage.removeItem("role")
      localStorage.removeItem("no_induk")
    },
    handleSetting() {

    },
    handleProfile() {

    },

    onBell(){
      localStorage.setItem("flagTab",0)
      this.$router.push("/peminjaman/peminjaman");
    }
  }
}
</script>

<style lang="stylus" scoped></style>
